import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Home, ArrowLeft, Search, AlertCircle } from 'lucide-react';
import { Button } from './index';
import './NotFound.css';

const NotFound = ({ 
  title = '404 - Página no encontrada',
  message = 'La página que buscas no existe o ha sido movida.',
  showSearch = true,
  customActions = null
}) => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleSearch = (e) => {
    e.preventDefault();
    const searchTerm = e.target.search.value.trim();
    if (searchTerm) {
      // Navigate to rooms page with search parameter
      navigate(`/habitaciones?search=${encodeURIComponent(searchTerm)}`);
    }
  };

  return (
    <div className="not-found-page">
      <div className="not-found-container">
        <div className="not-found-icon">
          <AlertCircle size={80} />
        </div>
        
        <div className="not-found-content">
          <h1>{title}</h1>
          <p className="not-found-message">{message}</p>
          
          <div className="not-found-suggestions">
            <h3>¿Qué puedes hacer?</h3>
            <ul>
              <li>Verifica que la URL esté escrita correctamente</li>
              <li>Regresa a la página anterior</li>
              <li>Ve a la página principal</li>
              <li>Explora nuestras habitaciones disponibles</li>
              {showSearch && <li>Busca lo que necesitas</li>}
            </ul>
          </div>
          
          {showSearch && (
            <form className="not-found-search" onSubmit={handleSearch}>
              <div className="search-input-group">
                <Search className="search-icon" size={20} />
                <input
                  type="text"
                  name="search"
                  placeholder="Buscar habitaciones..."
                  className="search-input"
                />
                <Button type="submit" variant="primary" size="small">
                  Buscar
                </Button>
              </div>
            </form>
          )}
          
          <div className="not-found-actions">
            {customActions || (
              <>
                <Button 
                  variant="outline" 
                  onClick={handleGoBack}
                  icon={ArrowLeft}
                >
                  Volver atrás
                </Button>
                
                <Button 
                  variant="primary" 
                  onClick={handleGoHome}
                  icon={Home}
                >
                  Ir al inicio
                </Button>
              </>
            )}
          </div>
        </div>
        
        <div className="not-found-footer">
          <p>¿Necesitas ayuda? Contáctanos para asistencia personalizada.</p>
        </div>
      </div>
    </div>
  );
};

export default NotFound;